import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSessionAdvisor } from '@/model/selectors';

type ResultsPendingAdvisor = Pick<
  Advisor,
  'advisorFirstName' | 'advisorLastName' | 'organizationDisplayName' | 'organizationName'
>;

function getAdvisorFullName({ advisorFirstName, advisorLastName }: ResultsPendingAdvisor) {
  return [advisorFirstName, advisorLastName]
    .map(part => part?.trim())
    .filter(Boolean)
    .join(' ');
}

function getOrganizationName({ organizationDisplayName, organizationName }: ResultsPendingAdvisor) {
  return organizationDisplayName?.trim() || organizationName?.trim() || '';
}

export function getResultsPendingCopy(advisor: ResultsPendingAdvisor) {
  const advisorName = getAdvisorFullName(advisor);
  const organizationName = getOrganizationName(advisor);
  const fromOrganization = organizationName ? ` from ${organizationName}` : '';

  return {
    headline: `${advisorName || 'Your advisor'}${fromOrganization} has your long-term care predictions.`,
    connectLabel: `Connect with ${advisorName || 'your advisor'}`,
  };
}

export function useResultsPending() {
  const [isRequestMeetingOpen, setIsRequestMeetingOpen] = useState(false);
  const advisor = useSelector(selectSessionAdvisor);
  const { headline, connectLabel } = getResultsPendingCopy(advisor);

  return {
    headline,
    connectLabel,
    isRequestMeetingOpen,
    openRequestMeeting: () => setIsRequestMeetingOpen(true),
    closeRequestMeeting: () => setIsRequestMeetingOpen(false),
  };
}
